module.exports = __webpack_public_path__ + "img/first-block-image.36332e96.webp";